import { render, staticRenderFns } from "./TheGroup.vue?vue&type=template&id=35c8cbab"
import script from "./TheGroup.vue?vue&type=script&lang=js"
export * from "./TheGroup.vue?vue&type=script&lang=js"
import style0 from "./TheGroup.vue?vue&type=style&index=0&id=35c8cbab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports